import usePassportMemberStatuses from '@/hooks/approval/usePassportMemberStatuses';
import type { MemberOrganization } from '@/utils/approval/passportMemberStatus';

const EMPTY_ORGANIZATIONS: ReadonlyMap<string, MemberOrganization | null> =
  new Map();

/** 조회 중·실패면 null — 빈 Map 으로 두면 '소속 불일치'와 구분 불가 */
const useMemberOrganizations = (
  passportIds: string[],
): ReadonlyMap<string, MemberOrganization | null> | null => {
  const { data, error } = usePassportMemberStatuses(passportIds);
  if (passportIds.length === 0) return EMPTY_ORGANIZATIONS;
  return !error && data ? data.organizations : null;
};

export default useMemberOrganizations;
